import { useContext } from 'react';
import { KeyboardShortcutsContext } from '../../context/KeyboardShortcutsContext/KeyboardShortcutsContext';

export const useKeyboardShortcutsContext = () => {
  const context = useContext(KeyboardShortcutsContext);

  if (context.isProvided === false) {
    throw new Error(
      'useKeyboardShortcutsContext must be used within a KeyboardShortcutsContextProvider'
    );
  }

  return context;
};
